import { render, staticRenderFns } from "./TradingTradesExtra.vue?vue&type=template&id=6eb6ed45&scoped=true&"
import script from "./TradingTradesExtra.vue?vue&type=script&lang=js&"
export * from "./TradingTradesExtra.vue?vue&type=script&lang=js&"
import style0 from "./TradingTradesExtra.vue?vue&type=style&index=0&id=6eb6ed45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6ed45",
  null
  
)

export default component.exports